import React, { useState } from 'react'
import { HiOutlineDocumentChartBar } from "react-icons/hi2"; // policy analysis
import { FaLandmark } from "react-icons/fa"; // government advisory (changed from policy advocacy)
import { MdHealthAndSafety } from "react-icons/md"; // public health dialogues
import { FaGlobeAsia } from "react-icons/fa"; // Global Diaspora Engagement
import { FaHandsHelping } from "react-icons/fa"; // compassionate care

const Wedo = () => {
  const [showMore, setShowMore] = useState(false);

  const primaryItems = [
    {
      title: "Policy Analysis",
      icon: <HiOutlineDocumentChartBar />,
      points: [
        "Analyse and assess public health policies",
        "Evaluate policy Impact and outcomes",
        "Provide evidence-based insights",
      ],
      bgColor: "bg-blue-900",
      titleColor: "text-orange-600",
    },
    {
      title: "Policy Advocacy",
      icon: <FaLandmark />,
      points: [
        "Advocate for evidence-based policy changes",
        "Promote Health Equity and Equitable Healthcare ",
        "Facilitate exchange of implemented global policies’ excellence ",
      ],
      bgColor: "bg-orange-600",
      titleColor: "text-blue-900",
    },

       {
      title: "Compassionate Care",
      icon: <FaHandsHelping />,
      points: [
        "Promote patient-centered healthcare approaches",
        "Advocate for empathetic healthcare systems",
        "Support mental health and wellbeing initiatives",
      ],
      bgColor: "bg-blue-900",
      titleColor: "text-orange-600",
    },
 
    {
      title: "Global Diaspora Engagement",
      icon: <FaGlobeAsia />,
      points: [
        "Mobilize diaspora experts for policy input",
        "Collaborate with Diaspora experts for Policy Inputs",
        "Build global perspectives and consensus to pre-empt, mitigate and manage rising GBD",
      ],
      bgColor: "bg-orange-600",
      titleColor: "text-blue-900",
    },
  ];

  const secondaryItems = [
 
       {
      title: "Public Health Dialogues",
      icon: <MdHealthAndSafety />,
      points: [
        "Facilitate inclusive discussions on health challenges",
        "Engage diverse stakeholders and experts",
        "Bridging the widening gaps in global healthcare systems",
      ],
      bgColor: "bg-blue-900",
      titleColor: "text-orange-600",
    },
  ];

  return (
    <div className='bg-blue-100/30'>
      {/* ================= WHAT WE DO ================= */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <h2 className="text-3xl lg:text-4xl font-bold text-center mb-16 text-blue-900">
          What We Do
        </h2>

        {/* Primary Grid - 4 items */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {primaryItems.map((item, i) => (
            <div
              key={i}
              className="relative bg-white rounded-xl shadow-sm pt-14 p-6 hover:shadow-md transition"
            >
              {/* Icon / Logo */}
              <div className="absolute -top-7 left-1/2 -translate-x-1/2">
                <div className={`w-14 h-14 rounded-full ${item.bgColor} text-white flex items-center justify-center text-2xl shadow-md`}>
                  {item.icon}
                </div>
              </div>

              <h3 className={`text-lg font-semibold mb-4 text-center ${item.titleColor}`}>
                {item.title}
              </h3>

              <ul className="space-y-2 text-md text-black">
                {item.points.map((p, idx) => (
                  <li key={idx} className="flex items-start">
                    <span className="text-orange-600 mr-2">•</span>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Secondary Grid - 1 item (shown when showMore is true) */}
        {showMore && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mt-10">
            {secondaryItems.map((item, i) => (
              <div
                key={i}
                className="relative bg-white rounded-xl shadow-sm pt-14 p-6 hover:shadow-md transition"
              >
                {/* Icon / Logo */}
                <div className="absolute -top-7 left-1/2 -translate-x-1/2">
                  <div className={`w-14 h-14 rounded-full ${item.bgColor} text-white flex items-center justify-center text-2xl shadow-md`}>
                    {item.icon}
                  </div>
                </div>

                <h3 className={`text-lg font-semibold mb-4 text-center ${item.titleColor}`}>
                  {item.title}
                </h3>

                <ul className="space-y-2 text-md text-black">
                  {item.points.map((p, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="text-orange-600 mr-2">•</span>
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}

        {/* View More Button */}
        <div className="text-center mt-12">
          <button 
            className="bg-blue-900 text-white px-6 py-3 rounded-md hover:bg-blue-800 transition"
            onClick={() => setShowMore(!showMore)}
          >
            {showMore ? "View Less Dialogues" : "View More Dialogues"}
          </button>
        </div>
      </section>
    </div>
  )
}

export default Wedo